<template>
  <div
    class="conmon-top"
    id="event-identity"
  >
    <el-container>
      <el-main
        style="padding: 0"
        class="table-first-style"
      >
        <el-row
          class="search-title common-table-top"
          style="margin-top: 20px"
        >
          <el-col
            :span="4"
            class="table-title"
          >
            <i
              class="el-icon-document"
              style="font-weight: bold;"
            ></i>
            <span>模型列表</span>
          </el-col>
          <el-col :span="20">
          </el-col>
        </el-row>
        <el-table
          ref="multipleTable"
          :data="tableData"
          class="table"
          v-loading="loading"
        >
          <template slot="empty">
            <div class="newTableEmpty">没有更多数据了</div>
          </template>
          <el-table-column
            prop="name"
            label="产品模型名称"
            width=""
          ></el-table-column>
          <el-table-column
            prop="identity"
            label="模型ID"
          ></el-table-column>
          <el-table-column
            label="操作"
            width="120"
          >
            <template slot-scope="scope">
              <div
                class="op-link editColor" v-show="btnType.edit"
                @click="openDialog(scope.row)"
              >
                编辑
              </div>
              <div
                class="op-link" v-show="btnType.setting"
                @click="toSetAll(scope.row.id)"
              >
                配置
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
    </el-container>

    <!--默认事件编辑弹窗-->
    <el-dialog
      class="cellDialog"
      title="编辑模型"
      :visible.sync="adddialog"
      width="520px"
    >
      <el-form
        style="padding-right: 20px"
        ref="addForm"
        :model="addForm"
        :rules="rules"
      >
        <el-form-item
          label="产品模型名称:"
          :label-width="addLabelWidth"
          prop="name"
        >
          <el-input
            maxlength="20"
            type="text"
            v-model="addForm.name"
            auto-complete="off"
            placeholder="输入产品模型名称:"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="模型ID:"
          :label-width="addLabelWidth"
          prop="type_id"
        >
          <el-input
            disabled
            type="text"
            v-model="addForm.identity"
            auto-complete="off"
            placeholder="输入模型ID"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="margin-top: 10px"
      >
        <el-button
          class="dialog-cancel-btn"
          @click="adddialog = false"
          style="margin-left: 20px"
        >取 消</el-button>
        <el-button
          :disabled="disabled"
          class="dialog-confirm-btn"
          style="margin-right: 32px"
          type="primary"
          @click="confirmAdd"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCusTypes, editCusTypes } from '@/api/set.js'
import { butonsList,getMenId } from '@/api/analyse.js'
export default {
  name: 'customerEvent',
  data () {
    return {
      loading: true,
      tableData: [],
      attr_type: '',
      attrList: [
        {
          attr_name: '来源',
          attr_identity: 'source',
          attr_type: 'txt',
          disabled: true
        },
        {
          attr_name: '来源内容',
          attr_identity: 'source_content',
          attr_type: 'txt',
          disabled: true
        },
        {
          attr_name: '活动营销编码',
          attr_identity: 'serial_number',
          attr_type: 'txt',
          disabled: true
        }
      ],
      limit: 10,
      totalCount: 0,
      adddialog: false,
      createdialog: false,
      editCustomdialog: false,
      types: [],
      addForm: {
        name: '',
        identity: ''
      },
      createForm: {
        name: '',
        identity: '',
        score: '',
        stage_id: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入产品模型名称', trigger: 'blur' }
        ],
        type_id: [
          { required: true, message: '请输入类型ID', trigger: 'blur' }
        ]
      },
      stage: [],
      addLabelWidth: '110px',
      page: 1,
      editId: '',
      editNoSystemId: '',
      id: this.$route.query.id,
      disabled: false,
      btnType:{
        'edit':false,
        'setting':false
      }
    }
  },
  methods: {
    // 去配置
    toSetAll (id) {
      router.push({ path: '/home/set-product-attr', query: { id: id } })
    },
    queryBtnList(){
      var itemId = getMenId(this.$route.path)
       butonsList({systemCode: 'ZY_INTELLIQUOR',menuId:itemId})
        .then((res)=>{
          if(res.data.code == '200'){
            var btnList = this.btnType
            for(let i = 0, k = res.data.result.length; i < k; i ++){
              for(let m in btnList){
                if(res.data.result[i].perms.indexOf(m) != -1){
                  this.btnType[m] = true
                }
              }
            }
          }
        })
    },
    // 获取产品模型列表
    load () {
      this.loading = true
      getCusTypes(52).then((res) => {
        console.log(res)
        if (res.data.code == 200) {
          this.tableData = res.data.result
        }
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading () {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 系统事件编辑弹窗 确定
    confirmAdd () {
      this.disabled = true
      editCusTypes(this.addForm.name, this.addForm.identity, this.editId).then((res) => {
        if (res.data.code == 200) {
          this.adddialog = false
          this.disabled = false
          this.load()
          _g.toastMsg('success', '编辑成功')
        } else {
          this.disabled = false
          _g.toastMsg('error', res.data.message)
        }
      })
    },
    // 打开编辑弹窗
    openDialog (item) {
      this.adddialog = true
      this.addForm.name = item.name
      this.addForm.identity = item.identity
      this.editId = item.id
      console.log(this.addForm.identity)
    }
  },
  created () {
    this.load()
    this.queryBtnList()
  }
}
</script>

<style scoped>
.table-title {
  text-align: left;
}
.custom-attr {
  width: 450px;
  margin: 28px auto 0;
}
.custom-attr p {
  margin: 5px 15px;
  text-align: left;
}
.custom-attr-item {
  font-size: 14px;
  margin: 10px 18px 10px 13px;
  position: relative;
  display: flex;
  justify-content: space-between;
}
.add-custom-attr {
  width: 392px;
  margin: 0 auto 18px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}
.add-custom-attr .add-btn {
  padding: 10px 31px;
  color: #fff;
  border-radius: 4px;
  margin: 4px 0 0 0;
}
.el-icon-close {
  line-height: 36px;
  position: absolute;
  top: 0;
  right: -10px;
}
.num-btn {
  background: #05b324;
  border-color: #05b324;
}
.words-btn {
  background: #1980ff;
  border-color: #1980ff;
}
.money-btn {
  background: #ff9f00;
  border-color: #ff9f00;
}
</style>
